import { Component, type ErrorInfo, type ReactNode } from 'react';

/**
 * Rede de proteção contra tela branca.
 *
 * Quando um componente quebra, o React desmonta a árvore inteira e o operador fica
 * olhando para o nada — sem saber se é a internet, a sessão ou um defeito. Aqui a falha
 * vira uma tela legível, com o texto do erro para quem for reportar.
 */
interface Props {
  children: ReactNode;
}

interface Estado {
  erro: Error | null;
  onde: string;
}

export class FronteiraDeErro extends Component<Props, Estado> {
  override state: Estado = { erro: null, onde: '' };

  static getDerivedStateFromError(erro: Error): Partial<Estado> {
    return { erro };
  }

  override componentDidCatch(erro: Error, info: ErrorInfo): void {
    this.setState({ onde: info.componentStack?.split('\n').slice(0, 4).join('\n') ?? '' });
    console.error('[cockpit] erro não tratado', erro, info.componentStack);
  }

  override render(): ReactNode {
    const { erro, onde } = this.state;
    if (!erro) return this.props.children;

    return (
      <div className="envolucro">
        <div className="aviso erro" style={{ marginTop: 40 }}>
          <b>O cockpit encontrou um erro e parou esta tela.</b>
          <p style={{ marginTop: 10 }}>
            Recarregue a página. Se o erro voltar, mande este texto para a equipe:
          </p>
          <pre
            style={{
              marginTop: 12,
              fontSize: 11,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              opacity: 0.85,
            }}
          >
            {erro.message}
            {onde && `\n${onde}`}
          </pre>
          <button
            className="bt pequeno"
            style={{ marginTop: 14 }}
            onClick={() => window.location.assign('/')}
          >
            Voltar ao funil
          </button>
        </div>
      </div>
    );
  }
}
